// extracted by mini-css-extract-plugin
export default {"type-default":"VNeme8JX98MLcsF2u_jA","type-larger":"SKX5h4A87WGnoMcD4uqT","logo-lone":"Bz7O7SzJdvUMqZVsnd9w","common_bganimation":"qPCaQIUk1dzDaSexbBFk"};